import axios from "axios";

export interface Good {
  id?: string;
  companyId: string;
  companyLocationId: string;
  name: string;
  isDeleted?: boolean;
}

export async function getallGoodsByCompanyId(CompanyId: string) {
  return axios
    .get<Good[]>(`/Goodses/getallgoodsesbycompanyid `, {
      params: { CompanyId },
    })
    .then((res) => res.data.filter((good) => !good.isDeleted));
}

export async function addGood(good: Good) {
  return axios.post<Good>(`/Goodses/addgoods`, good).then((res) => res.data);
}

export async function updateGood(good: Good) {
  return axios.put<Good>(`/Goodses/updategoods`, good).then((res) => res.data);
}

export async function deleteGood(id: string) {
  return axios
    .delete(`/Goodses/deletegoods`, { data: { id } })
    .then((response) => response.data);
}
